import { SuggestionStatus } from '@/api/apis/multi-suggest';

export const SUGGESTED_STATUS_MAP: Record<SuggestionStatus, string> = {
  [SuggestionStatus.InProgress]: 'In Progress',
  [SuggestionStatus.Finished]: 'Finished',
  [SuggestionStatus.Failed]: 'Failed',
};

export const TABLE_COLUMNS = [
  {
    key: 'userFullName',
    label: 'INITIATED BY',
    isSortable: true,
  },
  {
    key: 'initialCase',
    label: 'INITIAL CASE',
    isSortable: false,
  },
  {
    key: 'targetCases',
    label: 'TARGET CASES',
    isSortable: false,
  },
  {
    key: 'initiatedDate',
    label: 'INITIATED DATE',
    isSortable: true,
  },
  {
    key: 'suggestedDate',
    label: 'SUGGESTED DATE',
    isSortable: true,
  },
  {
    key: 'lastReviewDate',
    label: 'LAST REVIEW DATE',
    isSortable: true,
  },
  {
    key: 'averageRating',
    label: 'RATING',
    isSortable: false,
  },
  {
    key: 'lastReview',
    label: 'LAST REVIEW',
    isSortable: false,
  },
  {
    key: 'suggestionStatus',
    label: 'STATUS',
    isSortable: false,
    minWidthClassName: 'min-w-[120px]',
  },
];
